import React from 'react';
import StaticPage, { Section } from './StaticPage';

export default function TrustSafety() {
  return (
    <StaticPage title="Trust & Safety" subtitle="How RentalX builds trust between students and landlords.">
      <Section title="Our Verification Process">
        <p>RentalX uses a multi-step verification process to ensure all landlords and properties on our platform are legitimate.</p>
        <div className="mt-4 space-y-4">
          {[
            { step: '1', title: 'Identity Verification', desc: 'Landlords must provide government-issued ID (driver\'s licence or passport) verified via our secure identity partner.' },
            { step: '2', title: 'Property Ownership Check', desc: 'We cross-reference property addresses against public title records and council databases.' },
            { step: '3', title: 'Phone Verification', desc: 'A unique code is sent to the landlord\'s mobile number to confirm they control that number.' },
            { step: '4', title: 'Ongoing Monitoring', desc: 'Listings are reviewed regularly and verified status can be revoked if community reports indicate issues.' },
          ].map((item, i) => (
            <div key={i} className="flex gap-4 p-4 bg-gray-50 rounded-lg">
              <div className="w-8 h-8 bg-[#094f6f] text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">{item.step}</div>
              <div>
                <p className="font-semibold text-gray-800">{item.title}</p>
                <p className="text-sm text-gray-600 mt-0.5">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Review System">
        <p>All reviews on RentalX are from verified users who have completed a stay at the property. We do not allow anonymous or unverified reviews. Landlords can respond publicly to all reviews.</p>
      </Section>

      <Section title="Dispute Resolution">
        <p>If a dispute arises between a landlord and student, RentalX provides a mediation service:</p>
        <ul className="list-disc list-inside space-y-2 mt-2">
          <li>Submit a dispute via your dashboard</li>
          <li>Our team contacts both parties within 2 business days</li>
          <li>We facilitate resolution based on the lease terms and applicable tenancy laws</li>
          <li>For unresolved cases, we refer parties to the relevant state tenancy tribunal</li>
        </ul>
      </Section>

      <Section title="Data & Privacy">
        <p>Your personal information is encrypted and stored securely. We never sell your data to third parties. Read our full <a href="/privacy" className="text-[#094f6f] underline">Privacy Policy</a>.</p>
      </Section>
    </StaticPage>
  );
}
